import { StepData } from '@/lib/Steppers';

export enum CREATE_DATA_SOURCE_CRM {
  SOURCE_DETAILS,
  UPDATE_PARAMETERS,
  UPDATE_FIELDS,
  CHECK_INSTALLATION,
  INSTALLATION_SUCCESS,
}

export const CREATE_DATA_SOURCE_CRM_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_CRM.SOURCE_DETAILS,
    title: 'data_source_edit:crm.steps.source_details',
  },
  {
    id: CREATE_DATA_SOURCE_CRM.UPDATE_PARAMETERS,
    title: 'data_source_edit:crm.steps.set_parameters',
  },
  {
    id: CREATE_DATA_SOURCE_CRM.UPDATE_FIELDS,
    title: 'data_source_edit:crm.steps.set_fields',
  },
  {
    id: CREATE_DATA_SOURCE_CRM.CHECK_INSTALLATION,
    title: 'data_source_edit:crm.steps.check_installation',
  },
    {
    id: CREATE_DATA_SOURCE_CRM.INSTALLATION_SUCCESS,
    title: 'data_source_edit:crm.steps.installation_success',
  },
];
